import React, {
  useCallback,
  useEffect,
  useState,
} from "react";

import {
  Box,
  CircularProgress,
} from "@mui/material";

import GeneralLayout from "components/PageLayouts/GeneralLayout";

import MapDetail from "./Map/MapDetail";
import MapLeftDrawer from "./Map/MapLeftDrawer";

import {
  addressesAPI,
} from "api/Community/AddressesAPI";

import {
  Address,
} from "api/Community/CommunityInterfaces";


/*
 * Import the same community API and output-node
 * function that you currently pass into
 * addCommunityToNode.
 *
 * Change these import names if your existing
 * CommunityAPI exports use different names.
 */
import {
  communityAPI,
  getOutputNodes,
} from "api/Community/CommunityAPI";


const Map: React.FC = () => {
  const [
    allAddresses,
    setAllAddresses,
  ] = useState<Address[]>([]);

  const [
    displayedAddresses,
    setDisplayedAddresses,
  ] = useState<Address[]>([]);

  const [
    loading,
    setLoading,
  ] = useState(true);


  /* -------------------------------------------------------------------------- */
  /* Load all addresses                                                         */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    addressesAPI
      .getAll()
      .then(
        (
          addresses: Address[]
        ) => {
          setAllAddresses(
            addresses
          );

          setDisplayedAddresses(
            addresses
          );
        }
      )
      .catch(
        (error) => {
          console.error(
            "Error loading addresses:",
            error
          );
        }
      )
      .finally(() =>
        setLoading(false)
      );
  }, []);


  /* -------------------------------------------------------------------------- */
  /* Drawer selection changed                                                   */
  /* -------------------------------------------------------------------------- */

  const handleAddressesChange =
    useCallback(
      (
        addresses: Address[]
      ) => {
        setDisplayedAddresses(
          addresses
        );
      },
      []
    );


  /* -------------------------------------------------------------------------- */
  /* Loading                                                                    */
  /* -------------------------------------------------------------------------- */

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent:
            "center",
          mt: 5,
        }}
      >
        <CircularProgress />
      </Box>
    );
  }


  /* -------------------------------------------------------------------------- */
  /* Render                                                                     */
  /* -------------------------------------------------------------------------- */

  return (
    <GeneralLayout
      useLeftDrawer
      defaultOpenLeft={
        true
      }
      leftDrawerContent={
        <MapLeftDrawer
          allAddresses={
            allAddresses
          }
          communityAPI={
            communityAPI
          }
          getOutputNodes={
            getOutputNodes
          }
          onAddressesChange={
            handleAddressesChange
          }
        />
      }
    >
      <MapDetail
        data={
          displayedAddresses
        }
      />
    </GeneralLayout>
  );
};


export default Map;